import { jsx } from 'react/jsx-runtime';
import { TransformComponent } from 'react-zoom-pan-pinch';

const ScalableContainer = ({ children }) => {
  return /* @__PURE__ */ jsx(TransformComponent, {
    wrapperClass: "transform-wrapper",
    children
  });
};

export { ScalableContainer as default };
//# sourceMappingURL=ScalableContainer.js.map
